





















import {
  defineComponent,
  ref,
  PropType,
  watch,
  computed
} from '@vue/composition-api';
import { useFetchBankPaymentInstructions } from '@/composable/bank';
import { IBankPaymentInstruction, IBankPaymentInstructionData } from '@/models';
import { IFieldErrors } from '@/models/error/error.types';
import { FieldErrors } from '@/models/error/error';

export default defineComponent({
  name: 'PaymentInstructionPicker',

  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    value: [Number, Object] as PropType<
      number | IBankPaymentInstruction | IBankPaymentInstructionData | null
    >,

    externalErrorMessage: {
      type: [Array, Object] as PropType<string[] | IFieldErrors | null>,
      default: () => []
    }
  },
  emits: ['input', 'change'],
  setup(props, { emit }) {
    const lazyValue = ref(props.value);
    const loading = ref(false);

    const internalValue = computed({
      get: () => lazyValue.value,
      set: val => {
        lazyValue.value = val;
        emit('input', val);
        emit('change', val);
      }
    });

    watch(
      () => props.value,
      (val: any) => {
        lazyValue.value = val;
      },
      { immediate: true }
    );

    const {
      paymentInstructions,
      error,
      isLoading
    } = useFetchBankPaymentInstructions(null);

    function clearErrors(): void {
      error.value = '';
    }

    const errorMessageList = computed(() => {
      if (!props.externalErrorMessage) {
        return [];
      }
      const errors =
        Array.isArray(props.externalErrorMessage) ||
        !FieldErrors.isFieldError(props.externalErrorMessage)
          ? props.externalErrorMessage
          : (props.externalErrorMessage.value as string[]);
      return errors.concat(error.value);
    });

    return {
      internalValue,
      isLoading,
      paymentInstructions,
      lazyValue,
      errorMessageList,
      loading,
      clearErrors
    };
  }
});
